import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const menuItems = [
  { name: "Book", path: "/book" },
  { name: "Stories", path: "/stories" },
  { name: "Home", path: "/home" },
  { name: "Tools", path: "/Dohsatherapypractice" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

function Header() {
  const [activeMenu, setActiveMenu] = useState("Home");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // update active menu based on path
    if (location.pathname === "/" || location.pathname === "/home" || location.pathname === "/terms-and-condition") {
      setActiveMenu("Home");
    } else {
      const current = menuItems.find(item => item.path === location.pathname);
      if (current) setActiveMenu(current.name);
    }
    // Close sidebar on route change
    setIsSidebarOpen(false);
  }, [location.pathname]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <header className="navbar" id="navbar">
      <Link to="/home" className="logo">
        <img src={require("../assets/images/logo.png")} alt="ikigai365logo" width="140" />
      </Link>

      {/* Desktop Menu */}
      <nav className="nav-center">
        <ul className="nav-links">
          <li><Link to="/book" className={activeMenu === "Book" ? "active" : ""}>Book</Link></li>
          <li><Link to="/stories" className={activeMenu === "Stories" ? "active" : ""}>Stories</Link></li>
          <li><Link to="/Dohsatherapypractice" className={activeMenu === "Tools" ? "active" : ""}>Tools</Link></li>
          <li><Link to="/about" className={activeMenu === "About" ? "active" : ""}>About</Link></li>
          <li><Link to="/contact" className={activeMenu === "Contact" ? "active" : ""}>Contact</Link></li>
        </ul>
      </nav>

      {/* Buy Now Button */}
      <a href="https://www.penguin.sg/book/this-is-ikigai365" target="_blank" rel="noopener noreferrer" className="cta-btn">
        <span className="material-icons-outlined"> favorite </span>
        Buy Now
      </a>

      {/* Mobile Menu Toggle */}
      <button className="menu-toggle" id="menuToggle" onClick={toggleSidebar}>
        <span className="material-icons-outlined">menu</span>
      </button>

      {/* Sidebar Overlay */}
      <div className={`sidebar-overlay ${isSidebarOpen ? "active" : ""}`} onClick={closeSidebar}></div>

      {/* Sidebar Menu */}
      <div className={`sidebar ${isSidebarOpen ? "active" : ""}`}>
        <div className="sidebar-header">
          <Link to="/home" className="logo"><img src={require("../assets/images/logo.png")} alt="ikigai365logo" width="140" /></Link>
          <button className="close-btn" onClick={closeSidebar}>
            <span className="material-icons-outlined">close</span>
          </button>
        </div>
        <ul className="sidebar-nav">
          <li><Link to="/book" className={activeMenu === "Book" ? "active" : ""} onClick={closeSidebar}>Book</Link></li>
          {/* <li><Link to="/home" className={activeMenu === "Home" ? "active" : ""} onClick={closeSidebar}>Home</Link></li> */}
          <li><Link to="/stories" className={activeMenu === "Stories" ? "active" : ""} onClick={closeSidebar}>Stories</Link></li>
          <li><Link to="/Dohsatherapypractice" className={activeMenu === "Tools" ? "active" : ""} onClick={closeSidebar}>Tools</Link></li>
          <li><Link to="/about" className={activeMenu === "About" ? "active" : ""} onClick={closeSidebar}>About</Link></li>
          <li><Link to="/contact" className={activeMenu === "Contact" ? "active" : ""} onClick={closeSidebar}>Contact</Link></li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
